import type { ChangelogEntry } from "../types";

/**
 * Funnet under v2-lanseringen: Innstillinger-sidene var gatet på
 * forelder-nøkkelen «innstillinger», som er åpen for alle roller fordi den
 * personlige Varsler-siden ligger under den. Alle roller kunne derfor åpne
 * admin-sidene ved å skrive URL-en, og eksterne landet rett i Organisasjon
 * etter innlogging. Skrevet som to punkter fordi folk kan ha en gammel
 * bokmerket Innstillinger-lenke som nå gir «siden finnes ikke».
 */
export const TILGANGSFIKSER_2026_10: ChangelogEntry = {
  id: "2026-10-01-tilgangsfikser",
  date: "2026-10-01",
  title: "Innstillinger viser bare det du har tilgang til",
  summary:
    "Sidene under Innstillinger sjekker nå tilgang hver for seg. Har du ikke tilgang til en av dem, kommer du heller ikke inn ved å gå direkte til adressen.",
  sections: [
    {
      heading: "Innstillinger",
      items: [
        {
          title: "Innstillinger-sidene sjekker tilgang hver for seg",
          kind: "rettet",
          body: "Før holdt det å ha Innstillinger-menyen for å kunne åpne Organisasjon, Økonomi, Drift og de andre sidene direkte på adressen, selv om de ikke sto i menyen din. Nå gjelder tilgangen per side, slik den alltid har vist i menyen. Har du bokmerket en slik side uten å ha tilgang til den, får du nå «siden finnes ikke».",
        },
        {
          title: "«Innstillinger» tar deg til den første siden du har",
          kind: "rettet",
          body: "Trykker du på Innstillinger uten å ha Organisasjon, havner du på Varsler i stedet for på en side du ikke får se.",
        },
      ],
    },
  ],
};
